import { useState, useEffect, useContext } from "react";
import styles from "./comunicados.module.css";
import Sidebar from "../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import api from "../../api";




const ITENS_POR_PAGINA = 8;

function toDDMMYYYY(isoDate) {
    if (!isoDate || isoDate === "0") return "0";
    const [y, m, d] = isoDate.split("-");
    return `${d}/${m}/${y}`;
}

function getSegundaEsexta() {
    const hoje = new Date();
    const diaSemana = hoje.getDay(); // 0=dom, 1=seg, ..., 6=sab
    const diffSegunda = diaSemana === 0 ? -6 : 1 - diaSemana;
    const segunda = new Date(hoje);
    segunda.setDate(hoje.getDate() + diffSegunda);
    const sexta = new Date(segunda);
    sexta.setDate(segunda.getDate() + 4);
    const fmt = d => d.toISOString().slice(0, 10);
    return { segunda: fmt(segunda), sexta: fmt(sexta) };
}

const FILTRO_KEY = "comunicados_filtro";

function isArquivado(item) {
    if (!item.datarq) return false;
    const partes = item.datarq.split("/");
    if (partes.length !== 3) return false;
    const [d, m, y] = partes;
    const dataArq = new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    return dataArq <= hoje;
}

function isAgendadoPendente(item) {
    if (item.tipcom !== "agendado") return false;
    if (!item.datcom) return true;
    const [d, m, y] = item.datcom.split("/");
    const hora = (item.horcom || "00:00").slice(0, 5); // garante formato HH:MM
    return new Date(`${y}-${m}-${d}T${hora}`) > new Date();
}

export default function Comunicados() {
    const navigate = useNavigate();
    const [comunicados, setComunicados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [paginaAtual, setPaginaAtual] = useState(1);

    const defaultFiltro = () => {
        const salvo = JSON.parse(sessionStorage.getItem(FILTRO_KEY) || "null");
        if (salvo) return salvo;
        const { segunda, sexta } = getSegundaEsexta();
        return { dataInicio: segunda, dataFim: sexta };
    };

    const [dataInicio, setDataInicio] = useState(() => defaultFiltro().dataInicio);
    const [dataFim, setDataFim] = useState(() => defaultFiltro().dataFim);
    const [contagemComentarios, setContagemComentarios] = useState({});
    const [filtroStatus, setFiltroStatus] = useState("todos");

    async function CarregarComunicados(datini = "0", datfin = "0") {

        try {

            setLoading(true)

            const response = await api.get(`/portal/comunicado/?datini=${toDDMMYYYY(datini)}&datfin=${toDDMMYYYY(datfin)}`)

            const data = response.data

            setComunicados(data)
            setPaginaAtual(1)

        } catch (error) {

            alert("Erro ao conectar com servidor : " + error)

        } finally {

            setLoading(false)

        }

    }

    function handleFiltrar() {
        const datini = dataInicio || "0";
        const datfin = dataFim || "0";
        CarregarComunicados(datini, datfin);
    }

    function handleLimparFiltro() {
        const { segunda, sexta } = getSegundaEsexta();
        setDataInicio(segunda);
        setDataFim(sexta);
        CarregarComunicados(segunda, sexta);
    }

    async function ArquivarComunicado(codcom) {
        if (!window.confirm("Arquivar este comunicado?")) return;
        try {
            await api.put(`/portal/arqcomunicado/?codcom=${codcom}`);
            CarregarComunicados(dataInicio, dataFim);
        } catch (error) {
            alert("Erro ao arquivar comunicado: " + error);
        }
    }

    async function ExcluirComunicado(codcom) {

        if (!window.confirm("Excluir comunicado?")) return

        try {

            setLoading(true)

            await api.delete(`/portal/comunicado/?codcom=${codcom}`)


            CarregarComunicados(dataInicio, dataFim);

        } catch (error) {

            alert("Erro ao conectar com servidor : " + error)

        } finally {

            setLoading(false)

        }

    }

    useEffect(() => {
        sessionStorage.setItem(FILTRO_KEY, JSON.stringify({ dataInicio, dataFim }));
    }, [dataInicio, dataFim]);

    useEffect(() => {
        CarregarComunicados(dataInicio, dataFim);
    }, []);

    useEffect(() => {
        const pagina = comunicados.slice(
            (paginaAtual - 1) * ITENS_POR_PAGINA,
            paginaAtual * ITENS_POR_PAGINA
        );
        if (pagina.length === 0) return;

        Promise.all(
            pagina.map(item =>
                api.get(`/colaborador/comentarios/?codcom=${item.codcom}`)
                    .then(res => ({ codcom: item.codcom, count: Array.isArray(res.data) ? res.data.length : 0 }))
                    .catch(() => ({ codcom: item.codcom, count: 0 }))
            )
        ).then(results => {
            const mapa = {};
            results.forEach(r => { mapa[r.codcom] = r.count; });
            setContagemComentarios(prev => ({ ...prev, ...mapa }));
        });
    }, [paginaAtual, comunicados]);


    const comunicadosFiltrados = comunicados.filter(item => {
        const arquivado = isArquivado(item);
        const agendado  = isAgendadoPendente(item);
        if (filtroStatus === "arquivado") return arquivado;
        if (filtroStatus === "agendado")  return agendado && !arquivado;
        if (filtroStatus === "ativo")     return !agendado && !arquivado;
        return true;
    });

    const totalPaginas = Math.ceil(comunicadosFiltrados.length / ITENS_POR_PAGINA);
    const comunicadosPagina = comunicadosFiltrados.slice(
        (paginaAtual - 1) * ITENS_POR_PAGINA,
        paginaAtual * ITENS_POR_PAGINA
    );

    return (

        <div className={styles.layout}>

            <Sidebar />

            <div className={styles.main}>

                <div className={styles.content}>

                    <div className={styles.pageHeader}>
                        <div>
                            <span className={styles.pageLabel}>Comunicação</span>
                            <h1 className={styles.pageTitle}>Gestão de Comunicados</h1>
                        </div>
                        <button className={styles.btnNovo} onClick={() => navigate("/comunicados/novo")}>
                            + Novo Comunicado
                        </button>
                    </div>

                    {/* FILTROS */}
                    <div className={styles.filtrosBar}>
                        <div className={styles.filtroGrupo}>
                            <label>Data início</label>
                            <input
                                type="date"
                                value={dataInicio}
                                onChange={e => setDataInicio(e.target.value)}
                            />
                        </div>
                        <div className={styles.filtroGrupo}>
                            <label>Data fim</label>
                            <input
                                type="date"
                                value={dataFim}
                                onChange={e => setDataFim(e.target.value)}
                            />
                        </div>
                        <button className={styles.btnFiltrar} onClick={handleFiltrar} disabled={loading}>
                            Filtrar
                        </button>
                        <button className={styles.btnLimpar} onClick={handleLimparFiltro} disabled={loading}>
                            Limpar
                        </button>

                        <div className={styles.statusTabs}>
                            {[
                                { key: "todos",     label: "Todos" },
                                { key: "ativo",     label: "Ativos" },
                                { key: "agendado",  label: "Agendados" },
                                { key: "arquivado", label: "Arquivados" },
                            ].map(tab => {
                                const count = tab.key === "todos" ? null : comunicados.filter(i => {
                                    const arq = isArquivado(i);
                                    const age = isAgendadoPendente(i);
                                    if (tab.key === "arquivado") return arq;
                                    if (tab.key === "agendado")  return age && !arq;
                                    if (tab.key === "ativo")     return !age && !arq;
                                    return true;
                                }).length;
                                return (
                                    <button
                                        key={tab.key}
                                        className={`${styles.statusTab} ${filtroStatus === tab.key ? styles.statusTabAtivo : ""}`}
                                        onClick={() => { setFiltroStatus(tab.key); setPaginaAtual(1); }}
                                    >
                                        {tab.label}
                                        {count !== null && (
                                            <span className={styles.statusCount}>{count}</span>
                                        )}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* COMUNICADOS */}

                    <div className={styles.postsGrid}>

                        {loading && Array.from({ length: ITENS_POR_PAGINA }).map((_, i) => (
                            <div key={i} className={styles.skeletonCard}>
                                <div className={styles.skeletonImagem} />
                                <div className={styles.skeletonBody}>
                                    <div className={styles.skeletonLinha} style={{ width: "80%" }} />
                                    <div className={styles.skeletonLinha} style={{ width: "50%" }} />
                                    <div className={styles.skeletonLinha} style={{ width: "60%" }} />
                                    <div className={styles.skeletonStats}>
                                        <div className={styles.skeletonBadge} />
                                        <div className={styles.skeletonBadge} />
                                        <div className={styles.skeletonBadge} />
                                        <div className={styles.skeletonBadge} />
                                    </div>
                                </div>
                            </div>
                        ))}

                        {!loading && comunicadosPagina.length === 0 && (
                            <p>Nenhum comunicado cadastrado.</p>
                        )}

                        {!loading && comunicadosPagina.map((item, index) => {
                            const agendado  = isAgendadoPendente(item);
                            const arquivado = isArquivado(item);
                            return (
                                <div
                                    key={index}
                                    className={`${styles.postCard} ${agendado ? styles.postCardAgendado : ""} ${arquivado ? styles.postCardArquivado : ""}`}
                                    onClick={() => navigate(`/comunicados/${item.codcom}`, { state: { comunicado: { ...item, totalComentarios: contagemComentarios[item.codcom] ?? 0 } } })}
                                >
                                    {item.imagem && (
                                        <div className={styles.postImage}>
                                            <img src={item.imagem} alt="" />
                                        </div>
                                    )}

                                    <div className={styles.postBody}>

                                        {agendado && (
                                            <div className={styles.badgeAgendado}>
                                                🕐 Agendado
                                                <span>{item.datcom}{item.horcom ? ` às ${item.horcom}` : ""}</span>
                                            </div>
                                        )}

                                        {arquivado && (
                                            <div className={styles.badgeArquivado}>
                                                📦 Arquivado
                                            </div>
                                        )}

                                        <h4 dangerouslySetInnerHTML={{ __html: item.titcom }} />

                                        <div className={styles.meta}>
                                            <span>{item.datcom}</span>
                                            <span>Grupo: {item.grupo}</span>
                                            <span>{item.setcom}</span>
                                        </div>

                                        <div className={styles.stats}>
                                            <span>👁️ {item.viscom}</span>
                                            <span>👍 {item.curtidas}</span>
                                            <span>❤️ {item.ameis}</span>
                                            <span>💬 {contagemComentarios[item.codcom] ?? "—"}</span>
                                        </div>

                                        <div className={styles.cardAcoes}>
                                            {!arquivado && (
                                                <button className={styles.btnArquivar} onClick={e => { e.stopPropagation(); ArquivarComunicado(item.codcom); }}>📦 Arquivar</button>
                                            )}
                                            <button className={styles.excluir} onClick={e => { e.stopPropagation(); ExcluirComunicado(item.codcom); }}>Excluir</button>
                                        </div>

                                    </div>
                                </div>
                            );
                        })}

                    </div>

                    {/* PAGINAÇÃO */}
                    {!loading && totalPaginas > 1 && (
                        <div className={styles.paginacao}>
                            <button
                                className={styles.btnPagina}
                                onClick={() => setPaginaAtual(p => p - 1)}
                                disabled={paginaAtual === 1}
                            >
                                ‹ Anterior
                            </button>

                            {Array.from({ length: totalPaginas }, (_, i) => i + 1).map(num => (
                                <button
                                    key={num}
                                    className={`${styles.btnPagina} ${paginaAtual === num ? styles.btnPaginaAtivo : ""}`}
                                    onClick={() => setPaginaAtual(num)}
                                >
                                    {num}
                                </button>
                            ))}

                            <button
                                className={styles.btnPagina}
                                onClick={() => setPaginaAtual(p => p + 1)}
                                disabled={paginaAtual === totalPaginas}
                            >
                                Próximo ›
                            </button>
                        </div>
                    )}

                </div>

            </div>

        </div>

    )
}